export default {
    controller: 'userMenuController',
    template: require('../views/user.menu.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/auth/components/user.menu.component.js